<h2 class="form-title">{{ titleName }}</h2>

@if (isLoading) {
<div class="loading">
  <app-loading-indicator />
</div>
}

<form (ngSubmit)="onSubmit()" [class.disabled]="isLoading" id="addProgramForm">
  <div class="control" id="addProgramName">
    <label for="name">Name</label>
    <input
      class="form-control"
      type="text"
      id="name"
      name="name"
      [(ngModel)]="enteredName"
    />
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <label for="selectedProgram">Targets:</label>

      @if (isLoadingTargets) {
      <div class="targets-loading-state">
        Loading latest targets...
      </div>
      }
      @if (targetsLoadError) {
      <div class="targets-loading-error">
        {{ targetsLoadError }}
        <button
          type="button"
          class="btn btn-link p-0 ms-2"
          (click)="refreshTargets()"
        >
          Retry
        </button>
      </div>
      }

      <p-pickList
        *ngIf="!isLoading && targets && selectedTargets"
        class="program-target-picklist show-available-targets"
        [source]="targets"
        [target]="selectedTargets()"
        dataKey="ID"
        [dragdrop]="true"
        [disabled]="isLoadingTargets"
        [scrollHeight]="'24rem'"
        [sourceStyle]="{ height: '100%' }"
        [targetStyle]="{ height: '100%' }"
        [style]="{ height: '500px' }"
        sourceHeader="Available Targets"
        targetHeader="Selected Targets"
        filterBy="TargetName"
        sourceFilterPlaceholder="Filter by Target Name"
        showTargetFilter="false"
        showSourceControls="false"
        showTargetControls="false"
        controlsPosition="top"
        (onMoveToTarget)="onTargetsMovedToProgram($event.items)"
        (onMoveAllToTarget)="onTargetsMovedToProgram($event.items)"
        (onMoveToSource)="onTargetsRemovedFromProgram($event.items)"
        (onMoveAllToSource)="onTargetsRemovedFromProgram($event.items)"
      >
        <ng-template let-targetItem pTemplate="item">
          <div>
            <div class="d-flex align-items-center gap-2">
              <div>
                <div class="picklist-label">Target Name (Type)</div>
                <div class="d-block">
                  {{
                    targetItem.TargetName +
                      " (" +
                      getTargetTypeLabel(targetItem.TargetType) +
                      ")"
                  }}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-pickList>
    </div>
  </div>

  <div style="padding-top: 10px; width: 100%" id="addProgramAddTarget">
    <button
      id="addTargetButton"
      style="width: 100%"
      class="side-menu-button2"
      (click)="addTarget($event)"
      [disabled]="loading"
    >
      Add New Target
    </button>
  </div>

  <div class="control" id="addProgramStatus">
    <label for="selectedStatus">Status:</label>
    <p-dropdown
      autoWidth="false"
      [style]="{ width: '100%' }"
      appendTo="body"
      [options]="statuses"
      [(ngModel)]="selectedStatus"
      name="selectedStatus"
      [checkmark]="true"
      [showClear]="true"
      optionLabel="text"
      optionValue="value"
      placeholder="Select a Status"
      (onClick)="onSelectedStatusDropdownClick()"
      id="addProgramStatusDropdown"
    />
  </div>

  <div class="control" id="addProgramSkillArea">
    <label for="selectedSkillArea">Skill Area:</label>
    <p-dropdown
      autoWidth="false"
      [style]="{ width: '100%' }"
      appendTo="body"
      [options]="skillAreas"
      [(ngModel)]="selectedSkillArea"
      name="selectedSkillArea"
      [checkmark]="true"
      optionLabel="SkillAreaName"
      [showClear]="true"
      placeholder="Select a Skill Area"
      (onClick)="onSelectedSkillAreaDropdownClick()"
      id="addProgramSkillAreaDropdown"
    />
  </div>


  <div class="control" id="addProgramSkillAcquisitionGoal">
    <label for="selectedSkillAcquisitionGoal">BSP Current Objective:</label>
    <p-dropdown
      class="ProgramSkillAcquisitionGoal-dropdown"
      autoWidth="false"
      [style]="{ width: '100%' }"
      [panelStyle]="{ maxWidth: '750px' }"
      appendTo="body"
      [options]="skillAcquisitionGoalOptions"
      [ngModel]="selectedSkillAcquisitionGoalValue()"
      (ngModelChange)="onSkillAcquisitionGoalChange($event)"
      name="selectedSkillAcquisitionGoal"
      [checkmark]="true"
      optionLabel="DropdownLabel"
      optionValue="DropdownValue"
      [showClear]="true"
      placeholder="Select a BSP Current Objective"
      (onClick)="onSelectedSkillAcquisitionGoalDropdownClick()"
      id="addProgramSkillAcquisitionGoalDropdown"
    >
      <ng-template let-skillAcquisitionGoalItem pTemplate="item">
        <div class="d-flex align-items-center gap-2">
          <div>
            <div class="d-block wrap-text">
              {{ skillAcquisitionGoalItem.DropdownLabel }}
            </div>
          </div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <div
    class="control"
    *ngIf="selectedSkillAcquisitionGoal() && !isOtherSkillAcquisitionGoalSelected()"
  >
    <label>Objective Details:</label>
    <div class="objective-details">
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.SkillArea">
        <div class="objective-details-label">Skill Area</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.SkillArea }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.Program">
        <div class="objective-details-label">Program</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.Program }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.GoalStatus">
        <div class="objective-details-label">Objective Status</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.GoalStatus }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.Goal">
        <div class="objective-details-label">Objective</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.Goal }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.BaselineDate">
        <div class="objective-details-label">Baseline Date</div>
        <div class="objective-details-value">
          {{
            selectedSkillAcquisitionGoal()?.BaselineDate | date : "MM/dd/yyyy"
          }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.Baseline">
        <div class="objective-details-label">Baseline</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.Baseline }}
        </div>
      </ng-container>
      <ng-container
        *ngIf="selectedSkillAcquisitionGoal()?.SociallySignificantInformation"
      >
        <div class="objective-details-label">Socially Significant Info</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.SociallySignificantInformation }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.Progress">
        <div class="objective-details-label">Progress</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.Progress }}
        </div>
      </ng-container>
      <ng-container *ngIf="selectedSkillAcquisitionGoal()?.PreviousGoal">
        <div class="objective-details-label">Previous Objective</div>
        <div class="objective-details-value">
          {{ selectedSkillAcquisitionGoal()?.PreviousGoal }}
        </div>
      </ng-container>
    </div>
  </div>

  <div
    class="control"
    *ngIf="
      selectedSkillAcquisitionGoal() &&
      !isOtherSkillAcquisitionGoalSelected() &&
      selectedSkillAcquisitionGoal()?.TreatmentGoals &&
      (selectedSkillAcquisitionGoal()?.TreatmentGoals?.length ?? 0) > 0
    "
  >
    <label for="selectedOtherCurrentObjective"
      >Treatment Goals that support this objective:</label
    >
    @for (goal of selectedSkillAcquisitionGoal()?.TreatmentGoals; track goal) {
    <div class="ms-3 d-flex align-items-center gap-2">
      <div>
        <div class="d-block mb-2 wrap-text text-white text-14">
          - {{ goal }}
        </div>
      </div>
    </div>
    }
  </div>

  <div
    class="control"
    id="addProgramOtherCurrentObjective"
    *ngIf="isOtherSkillAcquisitionGoalSelected()"
  >
    <label for="selectedOtherCurrentObjective">Other Current Objective:</label>
    <textarea
      class="form-control"
      id="otherCurrentObjective"
      name="otherCurrentObjective"
      [(ngModel)]="enteredOtherCurrentObjective"
    ></textarea>
  </div>

  <div class="control" id="addProgramDetails">
    <label for="details">Program Instructions</label>

    <div
      class="editor-container editor-container_classic-editor"
      #editorContainerElement
    >
      <div class="editor-container__editor">
        <div #editorElement>
          <ckeditor
            id="details"
            name="details"
            [editor]="Editor"
            [config]="editorConfig"
            [data]="programToEdit?.Details ?? ''"
            (change)="onDetailsChange($event)"
          ></ckeditor>
        </div>
      </div>
    </div>
  </div>

  <div id="dates">
    <div class="control-row">
      <div class="control no-margin">
        <label for="DateOpened">Date Opened</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateOpened"
          [(ngModel)]="dateOpened"
          autocomplete="off"
        />
      </div>

      <div class="control no-margin">
        <label for="DateBaselined">Date Probed</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateBaselined"
          [(ngModel)]="dateBaselined"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="control-row">
      <div class="control no-margin">
        <label for="DateMastered">Date Mastered</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateMastered"
          [(ngModel)]="dateMastered"
          autocomplete="off"
        />
      </div>

      <div class="control no-margin">
        <label for="DateClosed">Date Closed</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control form-control"
          name="dateClosed"
          [(ngModel)]="dateClosed"
          autocomplete="off"
        />
      </div>
    </div>
  </div>

  <p class="actions d-flex justify-content-between" id="addProgramActions">
    <button
      class="w-100 mx-2"
      type="button"
      (click)="onCancel()"
      style="margin-right: auto"
    >
      Cancel
    </button>
    @if (programToEdit) {
    <button
      class="w-100 mx-2"
      type="button"
      id="archiveButton"
      [disabled]="loading"
      (click)="archiveButtonClicked()"
    >
      {{ programToEdit!.IsArchived ? "Unarchive" : "Archive" }}
    </button>
    }
    <button
      class="w-100 mx-2"
      type="submit"
      id="saveProgramButton"
      [disabled]="loading"
    >
      {{ actionName }}
    </button>
  </p>
</form>
